"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEndpoint = createEndpoint;
exports.createStreamEndpoint = createStreamEndpoint;
exports.createDeleteEndpoint = createDeleteEndpoint;
exports.createGetEndpoint = createGetEndpoint;
exports.createPatchEndpoint = createPatchEndpoint;
exports.createPutEndpoint = createPutEndpoint;
exports.createPostEndpoint = createPostEndpoint;
exports.createGetStreamEndpoint = createGetStreamEndpoint;
const _types_1 = require("../@types/index.js");
const sonarFetch_1 = require("./sonarFetch.js");
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function isFunction(fn) {
    return typeof fn === 'function';
}
function createEndpoint(action, uri, options) {
    return function post(request) {
        const targetUri = isFunction(uri) ? uri(request) : uri;
        const headers = isFunction(options === null || options === void 0 ? void 0 : options.headers) ? options === null || options === void 0 ? void 0 : options.headers(request) : options === null || options === void 0 ? void 0 : options.headers;
        const requestBody = isFunction(options === null || options === void 0 ? void 0 : options.requestTransform) ? options === null || options === void 0 ? void 0 : options.requestTransform(request) : request;
        const requestOptions = {
            headers,
            requestBody,
            skipAuthRefresh: options === null || options === void 0 ? void 0 : options.skipAuthRefresh,
            targetUri
        };
        switch (action) {
            case _types_1.HttpVerb.Delete:
                return (0, sonarFetch_1.sonarHttpDelete)(requestOptions);
            case _types_1.HttpVerb.Get:
                return (options === null || options === void 0 ? void 0 : options.responseIsBlob) ?
                    (0, sonarFetch_1.sonarHttpGetBlob)(requestOptions) :
                    (0, sonarFetch_1.sonarHttpGet)(requestOptions);
            case _types_1.HttpVerb.Patch:
                return (0, sonarFetch_1.sonarHttpPatch)(requestOptions);
            case _types_1.HttpVerb.Post:
                return (0, sonarFetch_1.sonarHttpPost)(requestOptions);
            case _types_1.HttpVerb.Put:
                return (0, sonarFetch_1.sonarHttpPut)(requestOptions);
            default:
                throw new Error('Invalid Http Verb');
        }
    };
}
function createStreamEndpoint(action, uri, options) {
    return function post(request) {
        const targetUri = isFunction(uri) ? uri(request) : uri;
        const headers = isFunction(options === null || options === void 0 ? void 0 : options.headers) ? options === null || options === void 0 ? void 0 : options.headers(request) : options === null || options === void 0 ? void 0 : options.headers;
        const requestBody = isFunction(options === null || options === void 0 ? void 0 : options.requestTransform) ? options === null || options === void 0 ? void 0 : options.requestTransform(request) : request;
        const requestOptions = {
            headers,
            requestBody,
            skipAuthRefresh: options === null || options === void 0 ? void 0 : options.skipAuthRefresh,
            targetUri
        };
        switch (action) {
            case _types_1.HttpVerb.Get:
                return (0, sonarFetch_1.sonarHttpGetStream)(requestOptions);
            default:
                throw new Error('Unsupported Http Verb');
        }
    };
}
function createDeleteEndpoint(uri, options) {
    return createEndpoint(_types_1.HttpVerb.Delete, uri, options);
}
function createGetEndpoint(uri, options) {
    return createEndpoint(_types_1.HttpVerb.Get, uri, options);
}
function createPatchEndpoint(uri, options) {
    return createEndpoint(_types_1.HttpVerb.Patch, uri, options);
}
function createPutEndpoint(uri, options) {
    return createEndpoint(_types_1.HttpVerb.Put, uri, options);
}
function createPostEndpoint(uri, options) {
    return createEndpoint(_types_1.HttpVerb.Post, uri, options);
}
function createGetStreamEndpoint(uri, options) {
    return createStreamEndpoint(_types_1.HttpVerb.Get, uri, options);
}
//# sourceMappingURL=createEndpoint.js.map